import { FuelButton, FuelTypography } from '@frete.com/fuel-react';
import { DS_TOKENS } from 'constants/styled.contants';
import useBlockedProfileEvents from 'hooks/events/useBlockedProfileEvents';
import React from 'react';
import * as Styled from './styled';

const RequestAccessCard: React.FC<{ setFullProfileAccessRequested: (state: boolean) => void }> = ({
  setFullProfileAccessRequested,
}) => {
  const { requestAccessOnButtonEvent } = useBlockedProfileEvents();

  const handleButtonGetAccessEvent = () => {
    setFullProfileAccessRequested(true);
    requestAccessOnButtonEvent();
  };

  return (
    <Styled.PositionedWrapper>
      <Styled.SpacingWrapper>
        <Styled.RequestAccessContent slot="content">
          <FuelTypography color="neutral-strong" weight="bold" size="body-lg">
            Perfil do motorista encontrado!
          </FuelTypography>
          <FuelTypography
            size="body-md"
            color="neutral-default"
            weight="medium"
            spacingBottom={parseFloat(DS_TOKENS.spacing.km4)}
          >
            Solicite o acesso a essa funcionalidade clicando no botão abaixo
          </FuelTypography>
          <FuelButton variant="secondary" size="medium" onClick={() => handleButtonGetAccessEvent()}>
            Quero ter acesso
          </FuelButton>
        </Styled.RequestAccessContent>
      </Styled.SpacingWrapper>
    </Styled.PositionedWrapper>
  );
};

export default RequestAccessCard;
